import { memo } from 'react';
import { TextField } from 'components/common';

interface FilterSearchProps {
  placeholder?: string;
  name?: string;
}

const FilterSearch = memo(({ name, placeholder }: FilterSearchProps) => {
  return <TextField name={name ?? 'q'} placeholder={placeholder ?? 'Search'} />;
});

FilterSearch.displayName = 'FilterSearch';

export default FilterSearch;
